import styled from 'styled-components';

/**
 * The read-only summary a geofence input shows until it is clicked, which opens its editor in a
 * modal. Shared by the zone input and the perimeter input so the two cannot drift: they sit next to
 * each other on the resident settings page and read as one pair.
 */

export const InputContainer = styled.div`
  width: 100%;
`;

export const InputLabel = styled.label`
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;

  display: block;

  margin-bottom: 10px;

  color: var(--midnight-blue);
`;

export const Value = styled.p`
  display: block;

  width: 100%;
  padding: 10px 15px;

  color: var(--comet);
  border: solid 1px #dee6f2;
  border-radius: 4px;
  background-color: var(--white);
  font-family: Poppins;
  cursor: pointer;

  &:hover {
    border: solid 1px var(--border-hover);
    box-shadow: 0 5px 20px 0 rgba(14, 12, 69, 0.1);
  }
`;
